import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { WbProductVariant } from '~/@types/product'

export default function useVariant(
  variants: WbProductVariant[],
  defaultVariant: WbProductVariant,
) {
  const router = useRouter()

  const [isAvailableForSale, setIsAvailableForSale] = useState<boolean>(true)
  const [selectedVariant, setSelectedVariant] = useState<WbProductVariant | null>()
  const queryKey = 'variant'
  // First load issue with next query router, we checked the asPath to be sure the variant was in the url
  const regex = new RegExp(`[&?]${queryKey}=(.*)(&|$)`)
  const matching = router.asPath.match(regex)
  let queryValue = router.query[queryKey] || matching ? matching?.[1] : null
  queryValue = decodeURIComponent(queryValue?.replace(/\+/g, ' ')) ?? null

  const currentVariant = queryValue
    ? variants?.find((variant) => {
        return variant?.title === queryValue
      })
    : null

  useEffect(() => {
    const variant = currentVariant || defaultVariant

    if (variant) setSelectedVariant(variant)
  }, [currentVariant, defaultVariant])

  useEffect(() => {
    const currentVariant =
      (selectedVariant
        ? selectedVariant
        : variants
        ? variants?.[0]
        : defaultVariant) ?? null

    if (currentVariant) {
      setIsAvailableForSale(currentVariant?.availableForSale)
    }
  }, [selectedVariant, variants, defaultVariant])

  const variantIndex = variants?.findIndex((item) => {
    return item?.id === selectedVariant?.id
  })

  return {
    selectedVariant,
    setSelectedVariant,
    variantIndex,
    isAvailableForSale,
  }
}
